document.addEventListener('DOMContentLoaded', function () {
    const heroSwiper = new Swiper('.js-category-swiper', {
        loop: true,
        slidesPerView: 2.5,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 5
            },
            1024: {
                slidesPerView: 8
            }
        }
    });

    const items = document.querySelectorAll('[js-category-item]');
    if (items) {
        items.forEach(function (item) {
            item.addEventListener('click', function () {
                items.forEach(function (b_item) {
                    b_item.classList.remove('is-active');
                });
                item.classList.add('is-active');
                let target = item.dataset.target;
                const containers = document.querySelectorAll('.js-category-container');
                containers.forEach(function (container) {
                    container.classList.remove('is-active');
                });

                containers.forEach(function (container) {
                    if (container.classList.contains(target)) {
                        container.classList.add('is-active');
                    }
                });
            });
        });
    }
});